 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A1_FRONTCOVER from '@/components/01_frontcover'
 import A2_FOUL from '@/components/02_foul'
 import A3_TITLEPAGE from '@/components/03_titlepage'
 import A4_COPYRIGHT from '@/components/04_copyright'
 import A5_TOC from '@/components/05_toc'
 import A6_ACKNOWLEDGEMENTS from '@/components/06_acknowledgements'
 import A7_INTRODUCTION from '@/components/07_introduction'
 import A8_CH11 from '@/components/08_ch11'
 import A9_CH12 from '@/components/09_ch12'
 import A0_CH13 from '@/components/10_ch13'
 import A1_CH14 from '@/components/11_ch14'
 import A2_CH15 from '@/components/12_ch15'
 import A3_CH21 from '@/components/13_ch21'
 import A4_CH22 from '@/components/14_ch22'
 import A5_CH23 from '@/components/15_ch23'
 import A6_CH24 from '@/components/16_ch24'
 import A7_CH25 from '@/components/17_ch25'
 import A8_CH26 from '@/components/18_ch26'
 import A9_CH27 from '@/components/19_ch27'
 import A0_CH28 from '@/components/20_ch28'
 import A1_CH29 from '@/components/21_ch29'
 import A2_CH31 from '@/components/22_ch31'
 import A3_CH41 from '@/components/23_ch41'
 import A4_CH42 from '@/components/24_ch42'
 import A5_CH43 from '@/components/25_ch43'
 import A6_CH44 from '@/components/26_ch44'
 import A7_CH45 from '@/components/27_ch45'
 import A8_CH51 from '@/components/28_ch51'
 import A9_CH52 from '@/components/29_ch52'
 import A0_CH53 from '@/components/30_ch53'
 import A1_CH54 from '@/components/31_ch54'
 import A2_CH55 from '@/components/32_ch55'
 import A3_CH61 from '@/components/33_ch61'
 import A4_CH71 from '@/components/34_ch71'
 import A5_CH72 from '@/components/35_ch72'
 import A6_CH73 from '@/components/36_ch73'
 import A7_CH74 from '@/components/37_ch74'
 import A8_CH75 from '@/components/38_ch75'
 import A9_CH76 from '@/components/39_ch76'
 import A0_CH77 from '@/components/40_ch77'
 import A1_CH81 from '@/components/41_ch81'
 import A2_CH82 from '@/components/42_ch82'
 import A3_CH83 from '@/components/43_ch83'
 import A4_CH84 from '@/components/44_ch84'
 import A5_CH85 from '@/components/45_ch85'
 import A6_CH91 from '@/components/46_ch91'
 import A7_CH92 from '@/components/47_ch92'
 import A8_CH93 from '@/components/48_ch93'
 import A9_CH94 from '@/components/49_ch94'
 import A0_CH95 from '@/components/50_ch95'
 import A1_CH101 from '@/components/51_ch101'
 import A2_CH111 from '@/components/52_ch111'
 import A3_CH112 from '@/components/53_ch112'
 import A4_CH113 from '@/components/54_ch113'
 import A5_CH114 from '@/components/55_ch114'
 import A6_CH115 from '@/components/56_ch115'
 import A7_CH116 from '@/components/57_ch116'
 import A8_CH117 from '@/components/58_ch117'
 import A9_CH121 from '@/components/59_ch121'
 import A0_CH131 from '@/components/60_ch131'
 import A1_CH132 from '@/components/61_ch132'
 import A2_CH133 from '@/components/62_ch133'
 import A3_CH134 from '@/components/63_ch134'
 import A4_CH135 from '@/components/64_ch135'
 import A5_CH136 from '@/components/65_ch136'
 import A6_CH137 from '@/components/66_ch137'
 import A7_CH138 from '@/components/67_ch138'
 import A8_CH139 from '@/components/68_ch139'
 import A9_CH141 from '@/components/69_ch141'
 import A0_CH142 from '@/components/70_ch142'
 import A1_CH143 from '@/components/71_ch143'
 import A2_CH144 from '@/components/72_ch144'
 import A3_CH151 from '@/components/73_ch151'
 import A4_CH161 from '@/components/74_ch161'
 import A5_CH162 from '@/components/75_ch162'
 import A6_CH163 from '@/components/76_ch163'
 import A7_CH164 from '@/components/77_ch164'
 import A8_CH165 from '@/components/78_ch165'
 import A9_CH166 from '@/components/79_ch166'
 import A0_CH167 from '@/components/80_ch167'
 import A1_CH171 from '@/components/81_ch171'
 import A2_CH172 from '@/components/82_ch172'
 import A3_CH173 from '@/components/83_ch173'
 import A4_CH174 from '@/components/84_ch174'
 import A5_CH175 from '@/components/85_ch175'
 import A6_CH176 from '@/components/86_ch176'
 import A7_CH177 from '@/components/87_ch177'
 import A8_CH181 from '@/components/88_ch181'
 import A9_CH182 from '@/components/89_ch182'
 import A0_CH183 from '@/components/90_ch183'
 import A1_CH184 from '@/components/91_ch184'
 import A2_CH185 from '@/components/92_ch185'
 import A3_CH191 from '@/components/93_ch191'
 import A4_CH192 from '@/components/94_ch192'
 import A5_CH193 from '@/components/95_ch193'
 import A6_CH194 from '@/components/96_ch194'
 import A7_CH195 from '@/components/97_ch195'
 import A8_CH201 from '@/components/98_ch201'
 import A9_CH202 from '@/components/99_ch202'
 import A00_CH211 from '@/components/100_ch211'
 import A01_CH212 from '@/components/101_ch212'
 import A02_CH213 from '@/components/102_ch213'
 import A03_CH221 from '@/components/103_ch221'
 import A04_CH222 from '@/components/104_ch222'
 import A05_CH223 from '@/components/105_ch223'
 import A06_CH224 from '@/components/106_ch224'
 import A07_CH231 from '@/components/107_ch231'
 import A08_CH232 from '@/components/108_ch232'
 import A09_CH233 from '@/components/109_ch233'
 import A10_CH234 from '@/components/110_ch234'
 import A11_CH235 from '@/components/111_ch235'
 import A12_CH236 from '@/components/112_ch236'
 import A13_CH237 from '@/components/113_ch237'
 import A14_CH238 from '@/components/114_ch238'
 import A15_CH239 from '@/components/115_ch239'
 import A16_CH241 from '@/components/116_ch241'
 import A17_CH242 from '@/components/117_ch242'
 import A18_CH243 from '@/components/118_ch243'
 import A19_CH251 from '@/components/119_ch251'
 import A20_CH261 from '@/components/120_ch261'
 import A21_CH262 from '@/components/121_ch262'
 import A22_CH263 from '@/components/122_ch263'
 import A23_CH271 from '@/components/123_ch271'
 import A24_CH272 from '@/components/124_ch272'
 import A25_CH273 from '@/components/125_ch273'
 import A26_CH281 from '@/components/126_ch281'
 import A27_CH282 from '@/components/127_ch282'
 import A28_CH283 from '@/components/128_ch283'
 import A29_CH284 from '@/components/129_ch284'
 import A30_CH285 from '@/components/130_ch285'
 import A31_CH291 from '@/components/131_ch291'
 import A32_CH292 from '@/components/132_ch292'
 import A33_CH293 from '@/components/133_ch293'
 import A34_CH301 from '@/components/134_ch301'
 import A35_CH302 from '@/components/135_ch302'
 import A36_CH303 from '@/components/136_ch303'
 import A37_CH304 from '@/components/137_ch304'
 import A38_CH305 from '@/components/138_ch305'
 import A39_CH306 from '@/components/139_ch306'
 import A40_CH307 from '@/components/140_ch307'
 import A41_CH311 from '@/components/141_ch311'
 import A42_CH312 from '@/components/142_ch312'
 import A43_CH313 from '@/components/143_ch313'
 import A44_CH314 from '@/components/144_ch314'
 import A45_CH315 from '@/components/145_ch315'
 import A46_CH316 from '@/components/146_ch316'
 import A47_CH317 from '@/components/147_ch317'
 import A48_CH318 from '@/components/148_ch318'
 import A49_CH319 from '@/components/149_ch319'
 import A50_CH321 from '@/components/150_ch321'
 import A51_CH322 from '@/components/151_ch322'
 import A52_CH323 from '@/components/152_ch323'
 import A53_CH324 from '@/components/153_ch324'
 import A54_CH325 from '@/components/154_ch325'
 import A55_CH326 from '@/components/155_ch326'
 import A56_CH327 from '@/components/156_ch327'
 import A57_CH331 from '@/components/157_ch331'
 import A58_CH332 from '@/components/158_ch332'
 import A59_CH333 from '@/components/159_ch333'
 import A60_CH334 from '@/components/160_ch334'
 import A61_CH335 from '@/components/161_ch335'
 import A62_CH341 from '@/components/162_ch341'
 import A63_CH342 from '@/components/163_ch342'
 import A64_CH343 from '@/components/164_ch343'
 import A65_CH351 from '@/components/165_ch351'
 import A66_CH361 from '@/components/166_ch361'
 import A67_CH362 from '@/components/167_ch362'
 import A68_CH363 from '@/components/168_ch363'
 import A69_AFTERWORD from '@/components/169_afterword'
 import A70_AFTERWORD1 from '@/components/170_afterword1'
 import A71_AFTERWORD2 from '@/components/171_afterword2'
 import A72_AFTERWORD3 from '@/components/172_afterword3'
 import A73_AFTERWORD4 from '@/components/173_afterword4'
 import A74_AFTERWORD5 from '@/components/174_afterword5'
 import A75_BIBLIOGRAPHY from '@/components/175_bibliography'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/05_toc",
 			"name" : "05_toc",
 			"component" : A5_TOC
 		},
 		{
 			"path" : "/06_acknowledgements",
 			"name" : "06_acknowledgements",
 			"component" : A6_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/07_introduction",
 			"name" : "07_introduction",
 			"component" : A7_INTRODUCTION
 		},
 		{
 			"path" : "/08_ch11",
 			"name" : "08_ch11",
 			"component" : A8_CH11
 		},
 		{
 			"path" : "/09_ch12",
 			"name" : "09_ch12",
 			"component" : A9_CH12
 		},
 		{
 			"path" : "/10_ch13",
 			"name" : "10_ch13",
 			"component" : A0_CH13
 		},
 		{
 			"path" : "/11_ch14",
 			"name" : "11_ch14",
 			"component" : A1_CH14
 		},
 		{
 			"path" : "/12_ch15",
 			"name" : "12_ch15",
 			"component" : A2_CH15
 		},
 		{
 			"path" : "/13_ch21",
 			"name" : "13_ch21",
 			"component" : A3_CH21
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js